import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { getLogIndexes, isLogArray } from '../../../utils/normalize-log';
import { ChangeHistory } from 'ag-common-svc/lib/components/changes-history-grid/change-history.model';
import { PushNotificationChannelsKeys } from '@ag-common-lib/lib';
import { ChangeLogsType } from '@ag-common-lib/lib/models/registration/change-logs.model';

@Component({
  selector: 'ag-shr-change-log-notifications-chanel',
  templateUrl: './change-log-notifications-channel.component.html',
  styleUrls: ['./change-log-notifications-channel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogNotificationsChannelComponent {
  @HostBinding('class') className = 'change-log-notifications-channel';
  @Input() set log(value: ChangeHistory) {
    this._log = value?.log;
    this.logIndexes = getLogIndexes(Object.entries(this._log));
  }

  get log(): Delta {
    return this._log;
  }

  private _log: Delta;
  logIndexes: number[];

  protected readonly isLogArray = isLogArray;
  protected readonly PushNotificationChannelsKeys = PushNotificationChannelsKeys;
  protected readonly ChangeLogsType = ChangeLogsType;
}
